'use client';

import React, { ReactNode } from 'react';

import { Button } from '@/component/parts/button/Button/Button';

export const CloseButton: React.FC<{
  icon: ReactNode;
  children: ReactNode;
}> = ({ icon, children }) => {
  return (
    <Button leftIcon={icon} onClick={() => window?.close()}>
      {children}
    </Button>
  );
};
